<div class="bar-container">
  <div
    [ngStyle]="{ width: width + '%' }"
    [class.comparison-current]="type === comparisonType.CURRENT"
    [class.good]="status === comparisonStatus.GOOD"
    [class.medium]="status === comparisonStatus.MEDIUM"
    [class.bad]="status === comparisonStatus.BAD"
    class="bar"
  ></div>
  <span [ngStyle]="{ 'margin-left': -width + '%' }" class="title primary-text">{{ title }}</span>
  <span class="amount primary-text">
    {{ amount | number: '1.0-2' }}
    {{ unit ? consumptionUnitType[unit] : (consumptionType | consumptionUnitTypePipe) }}
  </span>
</div>
